import React, { createContext, useEffect, useState } from 'react';
import { parseJwt } from '../utils/parseJwt';
import api from '../services/api';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [usuario, setUsuario] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');

    const carregarUsuario = async () => {
      if (!token) {
        setLoading(false);
        return;
      }

      const payload = parseJwt(token);
      setUsuario(payload);

      try {
        const { data } = await api.get('/me');
        setUsuario({ ...payload, ...data });
      } catch (_err) {
        setUsuario(payload);
      } finally {
        setLoading(false);
      }
    };

    carregarUsuario();
    
    // Teste do Spinner
    // -----------
    // setTimeout(() => {
    //   setLoading(false);
    // }, 1500);
    // -----------
  }, []);

  const logout = async () => {
    try {
      await api.post('/logout');
    } catch (_err) {
      // Mesmo se o registro de logout falhar, a sessao local deve ser encerrada.
    } finally {
      localStorage.removeItem('token');
      sessionStorage.removeItem('token');
      setUsuario(null);
      window.location.href = '/login';
    }
  };

  // Heartbeat para manter presenca online no backend/Redis. Depende do usuario
  // (e nao so do token na montagem) para comecar tambem logo apos o login, sem
  // recarregar a pagina -- caso da TV do Andon, que fica dias na mesma aba.
  const usuarioId = usuario?.id;
  useEffect(() => {
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    if (!token || !usuarioId) return undefined;

    const interval = setInterval(() => {
      api.get('/ping').catch(() => {
        // erros 401 serao tratados pelo interceptor
      });
    }, 90_000); // 90s

    return () => clearInterval(interval);
  }, [usuarioId]);

  return (
    <AuthContext.Provider value={{ usuario, setUsuario, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};
